module.exports = __webpack_public_path__ + "static/img/03.08df12f3.png";